/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ISymptom } from 'app/shared/model/symptom.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IAdmission } from 'app/shared/model/admission.model';

export interface IPatientSymptomHistory {
  id?: string;
  startDate?: number | null;
  endDate?: number | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
  symptom?: ISymptom | null;
  appointment?: IAppointments | null;
  admission?: IAdmission | null;
}

export const defaultValue: Readonly<IPatientSymptomHistory> = {
  active: false,
  draft: false,
};
